import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentCargoTypesPricingAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCargoPricing`,
    method: 'get',
  });
};

export type ShipmentCargoTypesPricingResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: 'Pricing';
  string2: null;
  string3: null;
}[];

export const fetchShipmentCargoTypesPricingList = async (): Promise<ShipmentCargoTypesPricingResponse> => {
  const response: AxiosResponse<ShipmentCargoTypesPricingResponse> = await getShipmentCargoTypesPricingAPI();
  return response.data;
};
